export const INITIAL_SIZE = { width: 500, height: 500 };
export const MAX_SIZE = { width: 10000, height: 10000 };
export const MIN_SIZE = { width: 300, height: 300 };
